import React from 'react';
import { Select, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { pickLabel } from './helpers';

const { Option } = Select;

/**
 * Единый блок управления — три фильтра-разреза + сброс.
 * Все три комбинируются и действуют на весь экран сразу (KPI, диаграммы, таблица).
 * Значения и подписи опций — из /api/schools/meta; «Все» — из клиентского словаря.
 */
export default function FiltersToolbar({ meta, filters, onChange, onReset }) {
  const { t, i18n } = useTranslation();
  const lng = i18n.language;
  const opts = meta?.filters || { shift: [], lang: [], status: [] };

  const renderSelect = (field, list) => (
    <Select
      className="sch-select"
      dropdownClassName="sch-select-dropdown"
      value={filters[field] || ''}
      onChange={(v) => onChange(field, v)}
      getPopupContainer={(node) => node.parentNode}
    >
      <Option value="">{t('schools.allOption')}</Option>
      {list.map((o) => (
        <Option key={o.value} value={o.value}>
          {pickLabel(o, lng)}
        </Option>
      ))}
    </Select>
  );

  return (
    <div className="sch-toolbar">
      <div className="sch-ctrl">
        <span className="sch-ctrl-label">{t('schools.filterShift')}</span>
        {renderSelect('shift', opts.shift)}
      </div>
      <div className="sch-ctrl">
        <span className="sch-ctrl-label">{t('schools.filterLang')}</span>
        {renderSelect('lang', opts.lang)}
      </div>
      <div className="sch-ctrl">
        <span className="sch-ctrl-label">{t('schools.filterStatus')}</span>
        {renderSelect('status', opts.status)}
      </div>
      <Button className="sch-reset" onClick={onReset}>
        {t('schools.reset')}
      </Button>
    </div>
  );
}
